import { SystemField } from "./system-field";

export class SiteNav  extends SystemField{
     
    ordering?: number;
    target?: string;
    site_nav_id?: string;
    icon?: string;
    is_divider?: number;
    is_header?: number;
    is_external?: number;

    // Import class translate
    langs?: any;
}


export class SiteNavTranslate  extends SystemField{
     
    lang_code?: string;
    name?: string;
    site_nav_id?: string;
}

export class PublicSiteNav extends SiteNav{}